{
	"hue": "{{range}} Hue",
	"luminance": "{{range}} Luminance",
	"panelColorGrading": "Color Grading",
	"rangeGlobal": "Global",
	"rangeHighlights": "Highlights",
	"rangeMidtones": "Midtones",
	"rangeShadows": "Shadows",
	"saturation": "{{range}} Saturation",
	"sliderBalance": "Balance",
	"sliderBlending": "Blending",
	"sliderHue": "Hue",
	"sliderLuminance": "Luminance",
	"sliderSaturation": "Saturation"
}
